/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTagAddPost } from '../fn/tag/api-master-tag-add-post';
import { ApiMasterTagAddPost$Params } from '../fn/tag/api-master-tag-add-post';
import { apiMasterTagDeleteGet } from '../fn/tag/api-master-tag-delete-get';
import { ApiMasterTagDeleteGet$Params } from '../fn/tag/api-master-tag-delete-get';
import { apiMasterTagEditPost } from '../fn/tag/api-master-tag-edit-post';
import { ApiMasterTagEditPost$Params } from '../fn/tag/api-master-tag-edit-post';
import { apiMasterTagGetActiveGet } from '../fn/tag/api-master-tag-get-active-get';
import { ApiMasterTagGetActiveGet$Params } from '../fn/tag/api-master-tag-get-active-get';
import { apiMasterTagGetAllGet } from '../fn/tag/api-master-tag-get-all-get';
import { ApiMasterTagGetAllGet$Params } from '../fn/tag/api-master-tag-get-all-get';
import { apiMasterTagGetByCriteriaPost } from '../fn/tag/api-master-tag-get-by-criteria-post';
import { ApiMasterTagGetByCriteriaPost$Params } from '../fn/tag/api-master-tag-get-by-criteria-post';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { Tag } from '../models/tag';
import { TagApiRespModel } from '../models/tag-api-resp-model';

@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTagAddPost()` */
  static readonly ApiMasterTagAddPostPath = '/api/Master/Tag/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagAddPost$Response(params?: ApiMasterTagAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TagApiRespModel>> {
    return apiMasterTagAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagAddPost(params?: ApiMasterTagAddPost$Params, context?: HttpContext): Observable<TagApiRespModel> {
    return this.apiMasterTagAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagApiRespModel>): TagApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTagEditPost()` */
  static readonly ApiMasterTagEditPostPath = '/api/Master/Tag/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagEditPost$Response(params?: ApiMasterTagEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TagApiRespModel>> {
    return apiMasterTagEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagEditPost(params?: ApiMasterTagEditPost$Params, context?: HttpContext): Observable<TagApiRespModel> {
    return this.apiMasterTagEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagApiRespModel>): TagApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTagDeleteGet()` */
  static readonly ApiMasterTagDeleteGetPath = '/api/Master/Tag/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagDeleteGet$Response(params?: ApiMasterTagDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTagDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagDeleteGet(params?: ApiMasterTagDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTagDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTagGetAllGet()` */
  static readonly ApiMasterTagGetAllGetPath = '/api/Master/Tag/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagGetAllGet$Response(params?: ApiMasterTagGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
    return apiMasterTagGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagGetAllGet(params?: ApiMasterTagGetAllGet$Params, context?: HttpContext): Observable<Array<Tag>> {
    return this.apiMasterTagGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Tag>>): Array<Tag> => r.body)
    );
  }

  /** Path part for operation `apiMasterTagGetActiveGet()` */
  static readonly ApiMasterTagGetActiveGetPath = '/api/Master/Tag/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagGetActiveGet$Response(params?: ApiMasterTagGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
    return apiMasterTagGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTagGetActiveGet(params?: ApiMasterTagGetActiveGet$Params, context?: HttpContext): Observable<Array<Tag>> {
    return this.apiMasterTagGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Tag>>): Array<Tag> => r.body)
    );
  }

  /** Path part for operation `apiMasterTagGetByCriteriaPost()` */
  static readonly ApiMasterTagGetByCriteriaPostPath = '/api/Master/Tag/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTagGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagGetByCriteriaPost$Response(params?: ApiMasterTagGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
    return apiMasterTagGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTagGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTagGetByCriteriaPost(params?: ApiMasterTagGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Tag>> {
    return this.apiMasterTagGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Tag>>): Array<Tag> => r.body)
    );
  }

}
